import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { studentParentsCrudStateConfig } from "../consts";

export const {
  fetchActionFactory: fetchStudentParentsActionFactory,
  updateActionFactory: updateStudentParentsActionFactory
} = makeCrudStateActionFactories(studentParentsCrudStateConfig);
